import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=150f55a2&scoped=true&"
import script from "./chat-message.vue?vue&type=script&lang=js&"
export * from "./chat-message.vue?vue&type=script&lang=js&"
import style0 from "./chat-message.vue?vue&type=style&index=0&id=150f55a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f55a2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150f55a2')) {
      api.createRecord('150f55a2', component.options)
    } else {
      api.reload('150f55a2', component.options)
    }
    module.hot.accept("./chat-message.vue?vue&type=template&id=150f55a2&scoped=true&", function () {
      api.rerender('150f55a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat-message.vue"
export default component.exports